import { Dialog } from 'primereact/dialog';
import { CardReference } from './AssignmentMonitoringCards';
import { Dispatch, FC, SetStateAction } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { getAssignmentStudentList } from '../../graphQLOperations/Assignment';
import { AssignmentsStudentListQuery } from '../../graphQLOperations/__generated__/AssignmentsStudentListQuery.graphql';
import { MaskedStudentData } from '../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../analytics/dataMasking';

interface Props {
  cardReference: CardReference;
  assignmentId: string;
  setCardReference: Dispatch<SetStateAction<CardReference | null>>;
}

export const AssignmentCardStudentListModal: FC<Props> = ({ cardReference, assignmentId, setCardReference }) => {
  const { assignmentProgressPercentageDetail } = useLazyLoadQuery<AssignmentsStudentListQuery>(
    getAssignmentStudentList,
    { assignmentId, type: cardReference.studentQueryKey },
    { fetchPolicy: 'network-only' },
  );

  return (
    <Dialog
      className="p-3 w-3"
      visible={true}
      header={<h4>{cardReference.label}</h4>}
      onHide={() => setCardReference(null)}
    >
      <div className="p-0 m-0">
        {assignmentProgressPercentageDetail.length ? (
          <ul className="m-0 p-0 list-none">
            {assignmentProgressPercentageDetail
              .map(el => el)
              .sort((a, b) => (a.lastName ?? '').localeCompare(b.lastName ?? '', undefined, { sensitivity: 'base' }))
              .map(student => (
                <li className="my-2" key={student.id}>
                  <MaskedStudentData
                    type={PiiTypes.FullName}
                    student={student}
                  >{`${student.firstName} ${student.lastName}`}</MaskedStudentData>
                </li>
              ))}
          </ul>
        ) : (
          <span className="text-400">No students</span>
        )}
      </div>
    </Dialog>
  );
};
